import { render, staticRenderFns } from "./VariantCard.vue?vue&type=template&id=41419892&scoped=true&"
import script from "./VariantCard.vue?vue&type=script&lang=js&"
export * from "./VariantCard.vue?vue&type=script&lang=js&"
import style0 from "./VariantCard.vue?vue&type=style&index=0&id=41419892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41419892",
  null
  
)

export default component.exports